module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/CD-d91b86ef63b61188f4dffe758eecc096.svg";